export const getCreditCardFormConfig = (city, cP4, cP3, addressLine1, addressLine2, invalidHolderErrorMessage) => {
    return `
        var wpwlOptions = {
            paymentTarget:"_top",
            style:"card", 
            locale: "pt",
            // Enable brand detection
            brandDetection: true,
            // Use our internal BIN list to precisely detect brands
            brandDetectionType: "binlist",
            // Give priority to detected brands
            brandDetectionPriority: ["VISA","MAESTRO","MASTER"],
            billingAddress: {
                country:"PT",
                state: "` + city + `",
                city: "` + city + `",
                postcode: "` + cP4 + "-" + cP3 + `",
                street1: "` + addressLine1 + `",
                street2: "` + addressLine2 + `",
            },
            mandatoryBillingFields:{
                country: true,
                state: true,
                city: true,
                postcode: true,
                street1: true,
                street2: false,
            },
            onReady: function(e){
                document.addEventListener("click", function (event) {
                // If the clicked element doesn\'t have the right selector, bail
                if (!event.target.matches(".wpwl-button-pay")) return;
                validateHolder();
            }, false);
        },
        onBeforeSubmitCard: function(e){
            return validateHolder();
        }
        };
        
        function validateHolder(){
            var holder = document.querySelector(".wpwl-control-cardHolder");
            
            if (holder.value.length < 3){
                holder.classList.add("wpwl-has-error");
                var newEl = document.createElement("div");
                newEl.className = "wpwl-hint wpwl-hint-cardHolderError";
                newEl.innerHTML = "` + invalidHolderErrorMessage + `";
                holder.parentElement.appendChild(newEl);
                return false;
            }
            return true;
        }`;
}